export default __webpack_public_path__ + "static/media/tnb-pic.b37172dd.png";